

































import {Prop, Vue, Component, Emit} from "vue-property-decorator";
import moment from "moment";

@Component({}) export default class extends Vue {
    dates = [];
    @Prop({default: {}}) data;
    duo = false;
    today = moment();
    selected = [];
    hoverDate = null;
    cb;

    mounted() {
        this.init();
    }


    isToday(date, day) {
        return moment(new Date(date.getFullYear(), date.getMonth(), day)).isSame(this.today, 'days');
    }

    onMouseEnter(date, val) {
        this.setHoverDate(new Date(date.getFullYear(), date.getMonth(), val));
    }

    setHoverDate(val) {
        this.hoverDate = val;
    }

    isAvailable(date, day) {
        return this.data.availability.filter(moment =>
            moment.isSame(new Date(date.getFullYear(), date.getMonth(), day), 'day')
        ).length !== 0;
    }

    init() {
        this.setDate(this.data.date ? this.data.date.toDate() : new Date());
    }

    setCb(val) {
        this.cb = val;
    }

    isActive(date, val) {
        if (!this.selected[0]) return false;

        let _date = new Date(date.getFullYear(), date.getMonth(), val);

        return _date.getTime() > this.selected[0].getTime() && _date.getTime() <= this.hoverDate.getTime() ||
            _date.getTime() < this.selected[0].getTime() && _date.getTime() >= this.hoverDate.getTime();
    }

    setDate(date) {
        let dates = [date];


        if (this.data.duo) dates.push(new Date(date.getFullYear(), date.getMonth() + 1));

        this.setDates(dates.map(this.normalizeDate.bind(this)));
    }

    isSameDate(date1, date2) {
        return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
    }

    isSelected(date, val) {
        if (!this.selected[0]) return false;

        return this.isSameDate(this.selected[0], new Date(date.getFullYear(), date.getMonth(), val));
    }

    setMonth(val) {
        let currentDate = this.dates[0].value;

        this.setDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + val))
    }


    normalizeDate(date) {
        return {
            dates: new Array(new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()).fill('x'),
            value: date,
            emptyDays: this.getEmptyDays(date)
        }
    }

    getDay(date, val) {
        let _val = val + 7 - (date.emptyDays.length ? date.emptyDays.length : 7),
            _date = new Date(date.value.getFullYear(), date.value.getMonth(), _val);

        return moment(_date).format('dd');
    }

    getEmptyDays(date) {
        let days = new Date(date.getFullYear(), date.getMonth(), 0).getDay() + 1;


        return new Array(days > 0 ? days - 1 : 0).fill('x');
    }

    setDuo(val) {
        this.duo = val;
    }

    setDates(val) {
        this.dates = val;
    }


    @Emit('change') addSelected(date, val) {
        this.selected.push(new Date(date.getFullYear(), date.getMonth(), val));

        if (!this.data.range) return this.selected[0];

        if (this.selected.length === 1) return false;

        let sorted = this.selected.sort((a, b) => a.getTime() > b.getTime() ? 1 : -1);

        this.selected = [];

        return {
            startDate: sorted[0],
            endDate: sorted[1]
        };
    }
}
